import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const ChevronDown = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => { }}
      style={style}
      width={width ? width : height ? height * (14 / 8) : 14}
      height={height ? height : width ? width * (8 / 14) : 8}
      viewBox="0 0 14 8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.9.36A1 1 0 10.49 1.77l5.8 5.8a1 1 0 001.42 0l5.8-5.8A1 1 0 0012.1.36L7 5.46 1.9.36z"
        id="ChevronDown"
        fill={color ? color : neutral[500]}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ChevronDown;
